<template>
  <div>
    <div id='navbar' class='navbar-container primary-green-bg'>

      <div :class='{"navbar-head": true, "padding-transition": hideHead}'>
        <div :class='{"logo-banner": true, "hide": hideHead, "fade-in":!hideHead}' @click="goHome"></div>
        <userlogo :class='{"hide": hideHead}'></userlogo>
        <button class='dropdown-toggle primary-green-bg' @click='toggleNavbar'><i class='fa fa-navicon fa-3x'></i></button>
      </div>

      <div class="nav-separator">
        <div class="mobile-nav">
          <div :class='{"dropdown": !navToggle}'>
            <div class="email-container">
              <div v-if="merchant" class="email-text-style">
                {{merchant}}
              </div>
              <div v-if="email" class="email-text-style">
                {{email}}
              </div>
            </div>
            <div :class='{"logo-banner-mini": true, "hide": !hideHead, "fade-in": hideHead}' @click="goHome"></div>
            <ul class='inline-block'>
              <router-link
                tag='li'
                active-class='active'
                :to='{name:"PendingApproval"}'>
                <span @click='navToggle = !navToggle'>Pending Approval</span>
              </router-link>

              <!-- <router-link
                tag='li'
                active-class='active'
                :to='{name:"PastOffers"}'>
                <span @click='navToggle = !navToggle'>Past Offers</span>
              </router-link> -->
              <router-link
                tag='li'
                active-class='active'
                :to='{name:"FileUpload"}'>
                <span @click='navToggle = !navToggle'>File Upload</span>
              </router-link>
            </ul>
            <ul class='inline-block right'>
              <router-link tag='li' active-class='active' :exact='true' to='/profile' class='right'><span @click='navToggle = !navToggle'>Profile</span></router-link>
              <li @click='logout' class='primary-green-bg uppercase'><span>Logout</span></li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    <div
      class="scroll"
      @resize='checkScrollAmount'
      @scroll='checkScrollAmount'
      :style='{"height":`${scrollHeight}px`}'>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Userlogo from './Userlogo'
import { mapActions, mapGetters } from 'vuex'
import { ACTION_NAV_BAR_COLLAPSE, GET_SELECTED_MERCHANT } from 'src/store/NameSpace'
import { isSuperUser, getVendorId } from 'src/components/shared/helper/superUser'

export default {
  data () {
    return {
      navToggle: false,
      hideHead: false,
      scrollHeight: 0,
      landingScreen: '/pending-offers',
      isSuperUser: false
    }
  },
  beforeMount () {
    if (isSuperUser()) {
      this.isSuperUser = true
    }
  },
  computed: {
    ...mapGetters({
      getSelectedMerchant: GET_SELECTED_MERCHANT
    }),
    email () {
      let vendor = getVendorId()
      if (vendor) {
        return vendor.name
      }
    },
    merchant () {
      let merchant = this.getSelectedMerchant
      if (merchant && merchant.name) {
        return merchant.name
      }
      return null
    }
  },
  components: {
    Userlogo
  },
  methods: {
    ...mapActions({
      actionCollapseNavBar: ACTION_NAV_BAR_COLLAPSE
    }),
    logout () {
      localStorage.clear()
      window.location.assign('/')
    },
    checkScrollAmount (e) {
      if (e.target.scrollTop > 20 && window.innerWidth >= 1000) {
        this.hideHead = true
        this.actionCollapseNavBar(true)
      }
      // else {
      //   this.hideHead = false
      // }
      this.adaptiveScreenHeight()
    },
    adaptiveScreenHeight () {
      let windowHeight = window.innerHeight
      let navHeight = document.getElementById('navbar').offsetHeight
      this.scrollHeight = windowHeight - navHeight - 10
    },
    toggleNavbar () {
      this.navToggle = !this.navToggle
      this.hideHead = (this.navToggle) ? false : this.hideHead
    },
    goHome () {
      this.$router.push(this.landingScreen)
    }
  },
  mounted () {
    this.adaptiveScreenHeight()
  }
}
</script>

<style scoped>
  button {
    paddin: 0;
    margin-right:.3rem;
    font-size: 1.2rem;
  }

  .hide {
    /*display: none;*/
    opacity: 0;
    height:0;
  }

  .padding-transition {
    padding: 0;
    height: 0;
  }
  .fade-in {
    opacity: 100;
    transition: opacity 1s ease-in;
  }
  .email-text-style {
    font-size: 1.2rem;
    color: white;
  }
  .email-container {
    position: absolute;
    left: 0;
    margin-left: 25rem;
    padding: 1rem;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// Navbar.vue?e1e7311e